var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has_market_price"},[_c('Header'),_c('MarketData'),_c('Footer'),_c('market-price')],1)}
var staticRenderFns = []

export { render, staticRenderFns }